import axios from 'axios';
import useSWR from 'swr';

import { isProd, PROXY_URL } from '@/shared/env';
import { AutocompleteResponse } from '@/types/Search';

import { getContinuationRequestId } from '../utils/continuation-local-storage';
import { CORRELATION_ID_HEADER_KEY } from './search-bar.constants';

const apiPrefix = isProd ? '/api' : PROXY_URL;

axios.interceptors.request.use((request) => {
  const corelationId = getContinuationRequestId(true);
  if (request.headers) {
    request.headers[CORRELATION_ID_HEADER_KEY] = corelationId;
  }

  return request;
});

export async function fetcher<T>(url: string, httpCorrelationId: string): Promise<T> {
  const res = await axios({
    url,
    method: 'GET',
    headers: { 'cor-id': httpCorrelationId },
  });

  return res.data;
}

export function useAutocomplete(
  searchTerm: string,
  httpCorrelationId: string,
  locale: string,
  searchVersion: string
) {
  const url = `${apiPrefix}/stores/autocomplete?${`q=${encodeURIComponent(
    searchTerm
  )}&locale=${locale}&search_version=${searchVersion}`}`;

  const { data: autocompleteData } = useSWR<AutocompleteResponse>(
    searchTerm ? [url, httpCorrelationId] : null,
    fetcher
  );

  return autocompleteData;
}
